import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-ticket-01-stroke',
  standalone: true,
  templateUrl: '../../assets/ticket-01-stroke.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamTicket01StrokeIcon {}
